import { Box, CircularProgress } from '@mui/material';
import { lazy, Suspense, useEffect, useState } from 'react';

import type { SiteSelect } from '@ui/Types/AuthServer';

// Lazy load ActivityChart component
const LazyActivityChart = lazy(() => import('../../Charts/ApexCharts/ActivityChart'));

// Loading fallback component
function LoadingFallback() {
    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                height: '100%',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            <CircularProgress />
        </Box>
    );
}

interface ChartWidgetProps {
    sites: SiteSelect[];
    title?: string;
}

export default function ChartWidget({ sites, title = 'Activity Statistics' }: Readonly<ChartWidgetProps>) {
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                width: '100%',
            }}
        >
            {isClient ? (
                <Suspense fallback={<LoadingFallback />}>
                    <LazyActivityChart sites={sites} title={title} />
                </Suspense>
            ) : (
                <LoadingFallback />
            )}
        </Box>
    );
}
